import React, { Fragment, useContext } from 'react';
import { useSelector } from 'react-redux';
import ResourceDisplay from 'field/display/ResourceDisplay';
import API from 'constants/api';
import LocaleContext from 'constants/localization';
import LocalizedStrings from 'react-localization';
import { isVideoType, defaultVideoJSOptions } from '../../../../helpers/mediaHelpers';
import VideoJS from '../../../common/VideoJS';


export default function ImageDisplay({ field }) {
  
  return (
    <Fragment>
      {
        field.values.map((value, i) => (
          <div className={'mdrow'} key={i}>
            <Image {...value} />
          </div>
        ))
      }
    </Fragment>
  );
}

// TODO change Image display and references to media
// end goal have "Media tab" which has images and videos
const Image = ({ uri, fields }) => {
  const LS = useContext(LocaleContext);
  const [customWidth, setCustomWidth] = React.useState(600);
  const primaryVersion = useSelector(state => state.object.primaryVersion);
  let projection = "NONE";
  fields && fields.forEach(field => {
    if(field.predicate === "http://www.profium.com/archive/photoDesc" && field.values[0].includes("360")){
      projection = "360"
    }
  });
  // video 
  if(isVideoType(uri)){
    const displayUri = `${API.DAM.DISPLAY_CONTENT}?uri=${uri}`
    const options = defaultVideoJSOptions(displayUri)
    return (
      <div className='resource digital-content' >
        <VideoJS options={options} projection={projection}/>
        <p>
          <a download style={{fontSize: '18px'}} target="_blank" 
            href={`${API.DAM.DISPLAY_CONTENT}?uri=${uri}`}>
            {LS.downloadVideo}
          </a>
        </p>
        {
        fields && fields.map((f, k) => <ResourceDisplay field={f} key={k} />)
        }
      </div>

    );

  }

  // image
  else{

    const getDisplay = type => `${API.DAM.DISPLAY_CONTENT}?uri=${uri}&type=${type}`;
    strings.setLanguage(LS.getLanguage());
  
    let version = "";
    if (primaryVersion === uri) {
      version = <p>{LS.primaryVersion}</p>;
    }
  
    return (
      <div className='resource digital-content'>
        <img src={getDisplay('thumb')} />
        {version}
        <div style={{margin: '1rem 0'}}>
          <a className="action-link" href={getDisplay('big')} target="_blank">
            <i className="fa fa-image"></i>
            {strings.big}
          </a>
          <a className="action-link" href={getDisplay('master')} target="_blank">
            <i className="fa fa-image"></i>
            {strings.master}
          </a>
          <a className="action-link" href={getDisplay(`customSize&width=${customWidth}`)} target="_blank">
            <i className="fa fa-image"></i>
            {strings.custom}
          </a>
          <input id="widthInput" value={customWidth} onChange={e => setCustomWidth(e.target.value)} />
          <label htmlFor="widthInput">{strings.imgWidth}</label>
        </div>
        {
          fields && fields.map((f, k) => <ResourceDisplay field={f} key={k} />)
        }
      </div>
    );
  }


};

const strings = new LocalizedStrings({
  fi: {
    big: 'Näyttökuva',
    master: 'Master',
    custom: 'Haluttu koko',
    imgWidth: 'Halutun koon pidempi sivu'
  },
  en: {
    big: 'Large',
    master: 'Master',
    custom: 'Custom size',
    imgWidth: 'Custom width'
  }
});